import { CASH_ON_HAND_DEPOSIT_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case CASH_ON_HAND_DEPOSIT_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}